import React, { useState } from 'react';
import { useAppSelector } from 'src/hooks';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';

import './section.scss';
import { Box } from '@mui/material';
import { IRouteMetadata } from 'src/components/layout/appDrawer/types/auth-response.model';
import AnalyzePortfolio from './analyze-portfolio-component';
import PlanPortfolio from './plan-portfolio-component';

function RenderLabelWithIcon(props: { path: string; text: string }) {
  const { path, text } = props;
  return (
    <div className='label-with-icon'>
      <img className='icon' src={path} />
      <span>{text}</span>
    </div>
  );
}

export default function PortfolioTabs({ parentHeightValue }) {
  const [value, setValue] = React.useState('1');

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  // getting the pages data
  const { navOptions } = useAppSelector((state) => state.appDrawer);

  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label='lab API tabs example'>
            <Tab
              label={
                <RenderLabelWithIcon
                  path='/static/images/analyse-icon.svg'
                  text='Analyse your portfolio'
                />
              }
              id='tab-0'
              aria-controls='tabpanel-0'
              sx={{ textTransform: 'none' }}
              value='1'
            />
            <Tab
              label={
                <RenderLabelWithIcon
                  path='/static/images/plan-portfolio-icon.svg'
                  text='Plan your portfolio'
                />
              }
              id='tab-1'
              aria-controls='tabpanel-1'
              sx={{ textTransform: 'none' }}
              value='2'
            />
          </TabList>
        </Box>
        <TabPanel
          value='1'
          sx={{ overflow: 'auto', padding: '10px' }}
          className='section-paper-div'
        >
          <AnalyzePortfolio pagesData={navOptions} />
        </TabPanel>
        <TabPanel
          value='2'
          sx={{ overflow: 'auto', padding: '10px' }}
          className='section-paper-div'
        >
          <PlanPortfolio pagesData={navOptions} />
        </TabPanel>
      </TabContext>
    </Box>
  );
}
